import { EmailTemplate } from "../../types/EmailTemplate";

export const TemplatePromo: EmailTemplate = {
  id: "promo",
  name: "Promotion / Code promo",
  description: "Offre commerciale avec badge de réduction et code promo mis en valeur",
  templateFile: "promo",
  previewData: {
    heroImage: "https://via.placeholder.com/600x200/ff8c00/ffffff?text=PROMO",
    discount: "-50%",
    title: "Offre exclusive IZI LIFE PAY",
    subtitle: "Profitez de frais réduits sur vos transferts",
    promoCode: "IZI2026",
    expiryDate: "31 décembre 2026",
    message:
      "Utilisez le code ci-dessus lors de votre prochain transfert pour bénéficier de la réduction.<br><br>Offre valable une fois par utilisateur.",
    ctaText: "J'en profite",
    ctaUrl: "https://izilifepay.com",
  },
  fields: [
    { name: "heroImage", label: "Bannière", type: "image", required: false },
    {
      name: "discount",
      label: "Badge réduction",
      type: "text",
      required: false,
      placeholder: "Ex: -50%",
      defaultValue: "-20%",
    },
    {
      name: "title",
      label: "Titre",
      type: "text",
      required: true,
      placeholder: "Ex: Offre exclusive",
      defaultValue: "Offre exclusive IZI LIFE PAY",
    },
    {
      name: "subtitle",
      label: "Sous-titre",
      type: "text",
      required: false,
      placeholder: "Ex: Frais réduits sur vos transferts",
    },
    {
      name: "promoCode",
      label: "Code promo",
      type: "text",
      required: true,
      placeholder: "Ex: IZI2026",
      defaultValue: "IZI2026",
    },
    {
      name: "expiryDate",
      label: "Date d'expiration",
      type: "text",
      required: false,
      placeholder: "Ex: 31 décembre 2026",
    },
    {
      name: "message",
      label: "Message",
      type: "textarea",
      required: true,
      placeholder: "Conditions et détails de l'offre...",
    },
    {
      name: "ctaText",
      label: "Texte du bouton",
      type: "text",
      required: true,
      defaultValue: "J'en profite",
    },
    {
      name: "ctaUrl",
      label: "Lien du bouton",
      type: "url",
      required: true,
      defaultValue: "https://izilifepay.com",
    },
  ],
};
